export default function validate(values) {
  let errors = {}
  if (!values.email) {
    errors.email = 'Your email is required'
  } else if (!/^[^@]+@.+\.[a-z]{2,}$/i.test(values.email)) {
    errors.email = 'Invalid email address'
  }
  return errors
}
